import React, { MouseEvent } from "react";
import ReactDOM from "react-dom";
import * as _ from "lodash"
// @ts-ignore
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceArea, ResponsiveContainer } from
    "recharts";

import * as SmartDrawings from "../../smartDrawings";

interface CountryViewChartProps {
    viewer: Autodesk.Viewing.GuiViewer3D,
    data: CountryData[]
}

interface CountryData {
    name: string,
    viewCount: number
}

export default class CountryViewChart extends React.Component<CountryViewChartProps> {

    constructor(props) {
        super(props);
    }

    componentWillMount(): void {

    }

    componentWillUnmount(): void {

    }

    render() {
        return (
            <ResponsiveContainer>
                <BarChart data={this.props.data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />

                    <Bar dataKey="viewCount" name="Model views" fill="#0000FF" />
                    <Bar dataKey="visitorCount" name="Unique visitors" fill="#00FF00" />

                </BarChart>
            </ResponsiveContainer>
        );
    }
}